import { Feature, User, UserRole } from 'types/user'
import { OrderFields, OrderFormData, OrderTypeId, isOrderTypeWithoutTsOwnerPhoneFields } from 'types/order'
import { phoneRegex } from 'utils/phone'
import { truckRegex } from 'utils/transport'

const OrderFormManagerRules = {
  [OrderFields.EXECUTOR]: 'required',
  [OrderFields.ORDER_DATE]: 'required|regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2})?$/',
  [OrderFields.CLIENT_NAME]: 'required',
  [OrderFields.ORDER_TEXT]: 'required',
  [OrderFields.ORDER_TYPE]: '',
  [OrderFields.PRIORITY]: '',
  [OrderFields.RESOLUTION]: '',
  [OrderFields.RESOLUTION_COMMENT]: '',
  [OrderFields.ORDER_COMMENT]: '',
  [OrderFields.LOGISTIC_NAME]: 'required',
  [OrderFields.LOGISTIC_INN]: 'required|regex:/^[0-9]{10}([0-9]{2})?$/',
  [OrderFields.LOGISTIC_OGRN]: 'required|regex:/^[0-9]{13}([0-9]{2})?$/',
  [OrderFields.LOGISTIC_ATI]: 'required',
  [OrderFields.LOGISTIC_FIRST_FACE]: 'required',
  [OrderFields.LOGISTIC_FIRST_FACE_BITH]: 'required|regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/|before:tomorrow',
  [OrderFields.LOGISTIC_FIRST_FACE_INN]: 'required|regex:/^[0-9]{10}([0-9]{2})?$/',
  [OrderFields.LOGISTIC_FIO]: 'required',
  [OrderFields.LOGISTIC_TEL]: ['required', phoneRegex],
  [OrderFields.LOGISTIC_TEL_2]: [phoneRegex],
  [OrderFields.CARRIER_FIRST_FACE_PHONE_1]: ['required', phoneRegex],
  [OrderFields.CARRIER_FIRST_FACE_PHONE_2]: [phoneRegex],
  [OrderFields.CARRIER_EMAIL]: 'regex:/[a-z0-9]!*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/',
  [OrderFields.DRIVER_FIO]: 'required',
  [OrderFields.DRIVER_BITH]: 'required|regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/|before:tomorrow|before:adultBirthDateLimit',
  [OrderFields.DRIVER_SER_NUM]: 'required',
  [OrderFields.DRIVER_DOC]: 'required',
  [OrderFields.DRIVER_DOC_DATE]: 'required|regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/|before:tomorrow',
  [OrderFields.DRIVER_DOC_EXPIRY_DATE]: 'regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/',
  [OrderFields.DRIVER_DATA_START_DT]: 'required|regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/|before:tomorrow',
  [OrderFields.DRIVER_TEL_1]: ['required', phoneRegex],
  [OrderFields.DRIVER_TEL_2]: [phoneRegex],
  [OrderFields.DRIVER_DATA_START_DT_STATUS]: '',
  [OrderFields.TS_OWNER]: 'required',
  [OrderFields.TS_OWNER_TEL]: ['required', phoneRegex],
  [OrderFields.TS_OWNER_LICENSE_PLATE]: ['required', truckRegex],
  [OrderFields.TRAILER_OWNER]: 'required',
  [OrderFields.TRAILER_OWNER_TEL]: ['required', phoneRegex],
  [OrderFields.TRAILER_OWNER_LICENSE_PLATE]: 'required',
  [OrderFields.ROUTE_DATE_START]: 'regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/',
  [OrderFields.ROUTE_TRIP]: '',
  [OrderFields.CARGO]: '',
  [OrderFields.SHIPPER]: '',
  [OrderFields.FILES]: '',
  [OrderFields.TRANSPORT_YEAR]: `min:1900|max:${new Date().getFullYear()}`,
  [OrderFields.TRANSPORT_STS_DATE]: 'required|regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/|before:tomorrow',
  [OrderFields.TRAILER_YEAR]: `min:1900|max:${new Date().getFullYear()}`,
  [OrderFields.TRAILER_STS_DATE]: 'required|regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/|before:tomorrow',
}

const OrderFormCustomerRules = {
  [OrderFields.EXECUTOR]: 'required',
  [OrderFields.ORDER_DATE]: 'required|regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2})?$/',
  [OrderFields.CLIENT_NAME]: 'required',
  [OrderFields.ORDER_TEXT]: '',
  [OrderFields.ORDER_TYPE]: 'required',
  [OrderFields.PRIORITY]: '',
  [OrderFields.RESOLUTION]: '',
  [OrderFields.RESOLUTION_COMMENT]: '',
  [OrderFields.ORDER_COMMENT]: '',
  [OrderFields.LOGISTIC_NAME]: 'required',
  [OrderFields.LOGISTIC_INN]: 'required|regex:/^[0-9]{10}([0-9]{2})?$/',
  [OrderFields.LOGISTIC_FIO]: 'required',
  [OrderFields.LOGISTIC_TEL]: ['required', phoneRegex],
  [OrderFields.LOGISTIC_TEL_2]: [phoneRegex],
  [OrderFields.CARRIER_FIRST_FACE_PHONE_1]: ['required', phoneRegex],
  [OrderFields.CARRIER_FIRST_FACE_PHONE_2]: [phoneRegex],
  [OrderFields.CARRIER_EMAIL]: '',
  [OrderFields.DRIVER_FIO]: 'required',
  [OrderFields.DRIVER_BITH]: 'required|regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/|before:tomorrow|before:adultBirthDateLimit',
  [OrderFields.DRIVER_TEL_1]: ['required', phoneRegex],
  [OrderFields.DRIVER_TEL_2]: [phoneRegex],
  [OrderFields.TS_OWNER]: 'required',
  [OrderFields.TRANSPORT_YEAR]: `min:1900|max:${new Date().getFullYear()}`,
  [OrderFields.TS_OWNER_TEL]: ['required', phoneRegex],
  [OrderFields.TS_OWNER_LICENSE_PLATE]: ['required', truckRegex],
  [OrderFields.TRAILER_OWNER]: 'required',
  [OrderFields.TRAILER_YEAR]: `min:1900|max:${new Date().getFullYear()}`,
  [OrderFields.TRAILER_OWNER_TEL]: ['required', phoneRegex],
  [OrderFields.TRAILER_OWNER_LICENSE_PLATE]: 'required',
  [OrderFields.ROUTE_DATE_START]: 'regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/',
  [OrderFields.ROUTE_TRIP]: '',
  [OrderFields.CARGO]: '',
  [OrderFields.SHIPPER]: '',
  [OrderFields.FILES]: '',
  'meta.kppExpectedDateFrom': 'regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2})?$/',
  'meta.kppExpectedDateTo': 'regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2})?$/',
  'meta.costOfCargo': 'regex:/^\\d+$/',
  'meta.routeDateEnd': 'regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/',
  'meta.insuredEmail': 'email',
}

const getOrderFormRules = (user: User, form: OrderFormData) => {
  const isLogisticAndDriver = String(form[OrderFields.ORDER_TYPE]) === OrderTypeId.LOGISTIC_AND_DRIVER
  const withoutTsOwnerPhones = isOrderTypeWithoutTsOwnerPhoneFields(form[OrderFields.ORDER_TYPE])
  const isEmailReceivingType = (form[OrderFields.META]?.documentsReceivingType || 'email') === 'email'

  // Только «перевозчик + водитель + ТС»: у клиента не показывают телефоны 1-го лица перевозчика — убираем их из правил валидации (не относится к собственнику ТС).
  const stripCarrierFirstFacePhones = (rules: { [key: string]: string | string[] }) => {
    if (!isLogisticAndDriver) return { ...rules }
    const { [OrderFields.CARRIER_FIRST_FACE_PHONE_1]: _1, [OrderFields.CARRIER_FIRST_FACE_PHONE_2]: _2, ...rest } = rules
    return rest
  }

  // Клиент, типы 1 / 2 / 6: не собираем телефоны собственника тягача и прицепа.
  const stripTsOwnerPhonesForCustomer = (rules: { [key: string]: string | string[] }) => {
    if (!withoutTsOwnerPhones) return { ...rules }
    const { [OrderFields.TS_OWNER_TEL]: _t, [OrderFields.TRAILER_OWNER_TEL]: _tr, ...rest } = rules
    return rest
  }

  switch (user!.role) {
    case UserRole.CUSTOMER:
      // eslint-disable-next-line no-case-declarations
      const result: { [key: string]: string | string[] } = { ...OrderFormCustomerRules }
      if (isEmailReceivingType) result[OrderFields.CARRIER_EMAIL] = 'required'

      if (form[OrderFields.META].insuranceConfirmed) {
        result['meta.insuredName'] = 'required'
        result['meta.insuredInn'] = 'required|regex:/^[0-9]{10}([0-9]{2})?$/'
        result['meta.insuredEmail'] = 'required|email'
        result[OrderFields.ROUTE_DATE_START] = 'required|regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/'
        result['meta.routeDateEnd'] = 'required|regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/'
        result[OrderFields.ROUTE_TRIP] = 'required'
        result[OrderFields.CARGO] = 'required'
        result['meta.costOfCargo'] = 'required|regex:/^\\d+$/'
      }

      if (user?.features?.[Feature.ALL_FIELDS_ARE_REQUIRED]) {
        result[OrderFields.ROUTE_DATE_START] = 'required|regex:/^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/'
        result[OrderFields.SHIPPER] = 'required'
        result[OrderFields.ROUTE_TRIP] = 'required'
        result[OrderFields.CARGO] = 'required'
      }

      return stripTsOwnerPhonesForCustomer(stripCarrierFirstFacePhones(result))

    default:
      return stripCarrierFirstFacePhones({ ...OrderFormManagerRules })
  }
}

export default getOrderFormRules
